import { jsx as c } from "react/jsx-runtime";
import { useState as H, useEffect as z } from "react";
import { I as F } from "./ic_arrowless_fill-DCwkJEfT.mjs";
import { c as I } from "./tw-cn-mXgPecoF.mjs";
import { F as L } from "./floating-button-COujqL1f.mjs";
const P = ({
  top: l,
  scrollBehavior: p = "smooth",
  targetRef: o,
  onClick: t,
  className: b,
  hasGnb: v = !1,
  style: x
}) => {
  const [d, a] = H(!1);
  z(() => {
    const u = (o == null ? void 0 : o.current) || window;
    let i = 0;
    const h = () => {
      i = 0;
      const w = o == null ? void 0 : o.current;
      if (w) {
        const { scrollTop: e, scrollHeight: r, clientHeight: n } = w, m = Math.min(e, r - n);
        a(m > (l ?? n));
      } else {
        const e = window.scrollY, r = document.documentElement.scrollHeight, n = window.innerHeight, m = Math.min(e, r - n);
        a(m > (l ?? n));
      }
    }, s = () => {
      i === 0 && (i = requestAnimationFrame(h));
    };
    return h(), u.addEventListener("scroll", s), window.addEventListener("resize", s), () => {
      u.removeEventListener("scroll", s), window.removeEventListener("resize", s), i !== 0 && cancelAnimationFrame(i);
    };
  }, [l, o == null ? void 0 : o.current]);
  const E = () => {
    ((o == null ? void 0 : o.current) || window).scrollTo({ top: 0, behavior: p }), t == null || t();
  };
  return /* @__PURE__ */ c(
    "div",
    {
      className: I(
        "fixed left-1/2 w-full max-w-mobile-size -translate-x-1/2 z-middle pc:bottom-24 pc:max-w-[none]",
        "transition-opacity duration-200 ease-[cubic-bezier(1,0,1,.7)]",
        d ? "opacity-100" : "opacity-0",
        v ? "bottom-80" : "bottom-16",
        b
      ),
      inert: d ? void 0 : "",
      style: x,
      children: /* @__PURE__ */ c("div", { className: "absolute bottom-0 right-16 pc:right-24", children: /* @__PURE__ */ c(L, { "aria-label": "맨 위로 가기", icon: /* @__PURE__ */ c(F, {}), onClick: E }) })
    }
  );
};
export {
  P as G
};
